import { render, staticRenderFns } from "./WhatsAppChat.vue?vue&type=template&id=4d52b25e&"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js&"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports